import { Injectable, InjectionToken } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '@environments/environment';
import { LocalRepository } from '@shared/helper/local-repository';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
// ! matrix:
// import { MatrixFilterModel } from '../http_services/Metrix_messages/models/sync';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

Injectable({
    providedIn: 'root',
})
export class HttpBaseService extends BaseService {
    protected apiUrl: string;
    protected fileUrl: string;
    jwtHelper: JwtHelperService;
    protected authenticationUrl: string = environment.AuthServicesUrl;

    constructor(
        repo: LocalRepository,
        protected http: HttpClient,
        private serviceName: string,
    ) {
        super(repo);
        this.apiUrl = `${environment.ServicesUrl}/${this.serviceName}`;
        this.fileUrl = `${environment.FileServicesUrl}/${this.serviceName}`;
        this.jwtHelper = new JwtHelperService();
    }

    public ServiceTermFilter(termFilter: TermFilterModel): string {
        let paramsValues = '';
        if (termFilter.pgNumber || termFilter.pgNumber == 0)
            paramsValues = `?PgNumber=${termFilter.pgNumber}`
        if (termFilter.pgSize)
            paramsValues = `?PgSize=${termFilter.pgSize}`
        if ((termFilter.pgNumber || termFilter.pgNumber == 0) && termFilter.pgSize)
            paramsValues = `?PgNumber=${termFilter.pgNumber}&PgSize=${termFilter.pgSize}`
        return paramsValues;
    }

    // ! matrix: matrix involved version of methods
    // public syncUrl(since?: string, filter?: MatrixFilterModel | string): string {
    //     let url: string = '';
    //     if (since != 'undefined' && since && since.length > 0) {
    //         url = `?since=${since}&filter=${this.syncUrlFilters(filter)}&timeout=20000`
    //     }
    //     else {
    //         url = '?filter=' + this.syncUrlFilters(filter);
    //     }
    //     return url;
    // }

    // public syncUrlFilters(filter: MatrixFilterModel | string): string {
    //     let result = JSON.stringify(filter);
    //     return result;
    // }

    public syncUrl(since?: string, filter?: string): string {
        let url = '';
        if (since != 'undefined' && since && since.length > 0) {
            url = `?since=${since}&filter=${this.syncUrlFilters(filter!)}&timeout=20000`
        }
        else {
            url = '?filter=' + this.syncUrlFilters(filter!);
        }
        return url;
    }

    public syncUrlFilters(filter: string): string {
        const result = JSON.stringify(filter);
        return result;
    }

}

